var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArRecordDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3799_8190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C10.8587 1.29396e-07 14 3.14125 14 7C14 10.8587 10.8587 14 7 14C3.14125 14 1.29391e-07 10.8587 0 7C0 3.14125 3.14125 0 7 0ZM7 1.16699C3.78292 1.16699 1.16699 3.78292 1.16699 7C1.16699 10.2171 3.78292 12.833 7 12.833C10.2171 12.833 12.833 10.2171 12.833 7C12.833 3.78292 10.2171 1.16699 7 1.16699ZM7 4.08301C8.61083 4.08301 9.91699 5.38917 9.91699 7C9.91699 8.61083 8.61083 9.91699 7 9.91699C5.38917 9.91699 4.08301 8.61083 4.08301 7C4.08301 5.38917 5.38917 4.08301 7 4.08301Z",
    fill: "#EA4645"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3799_8190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArRecordDot);
export default __webpack_public_path__ + "static/media/AR_record_dot.ed69978262c6306916428734746f5a3b.svg";
export { ForwardRef as ReactComponent };